import { useSite } from "@/context/SiteContext";
import { FadeUp } from "@/components/Reveal";

const TrustBar = () => {
    const { content } = useSite();
    const { trust } = content;

    return (
        <section data-testid="trust-bar" className="border-y border-slate-200 bg-white py-14">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <FadeUp>
                    <p className="text-center text-xs font-semibold uppercase tracking-[0.3em] text-slate-400">{trust.label}</p>
                    <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-12 gap-y-4">
                        {trust.logos.map((logo, i) => (
                            <li
                                key={logo}
                                data-testid={`trust-logo-${i}`}
                                className={`font-display text-lg text-slate-400 transition-colors hover:text-slate-600 ${
                                    i % 2 === 0 ? "font-extrabold tracking-tight" : "font-semibold italic tracking-wide"
                                }`}
                            >
                                {logo}
                            </li>
                        ))}
                    </ul>
                </FadeUp>

                <dl className="mx-auto mt-12 grid max-w-3xl grid-cols-1 gap-6 sm:grid-cols-3">
                    {trust.stats.map((stat, i) => (
                        <FadeUp key={stat.label} delay={i * 0.12}>
                            <div data-testid={`trust-stat-${i}`} className="flex flex-col rounded-2xl bg-mist px-6 py-6 text-center">
                                <dt className="order-2 mt-1 text-sm font-medium text-slate-500">{stat.label}</dt>
                                <dd className="order-1 font-display text-3xl font-extrabold text-royal sm:text-4xl">{stat.value}</dd>
                            </div>
                        </FadeUp>
                    ))}
                </dl>
            </div>
        </section>
    );
};

export default TrustBar;
